//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/PartCollection.js";
let d=[[[0,"AbortOnFailure",1,0],[0,"AllowSubstitution",1,0],[0,"BookmarkRefsetLoadBehavior",1,0],[0,"ComponentLoadMethod",1,0],[0,"ComponentsToLoad",1,0],[0,"GenerateMissingPartFamilyMembers",1,0],[0,"LoadLatest",1,0],[0,"ManagedModeComponentLoadMethod",1,0],[0,"OptionUpdateSubsetOnLoad",1,0],[0,"PartLoadOption",1,0],[0,"ReferenceOnlyComponentLoadOption",1,0],[0,"ReferenceSetOverride",1,0],[0,"SecondaryComponentsLoadOption",1,0],[0,"UseLightweightRepresentations",1,0],[0,"UsePartialLoading",1,0]],[[["interpart_option","parent_option"],"SetInterpartData",{},2,0],[["interpart_option","parent_option"],"GetInterpartData",{},0,0],[["restore_ant","restore_fully_loaded_status","components_load_option"],"SetBookmarkComponentsToLoad",{},3,0],[["restore_ant","components_load_option"],"GetBookmarkComponentsToLoad",{},0,0],[["search_directories","search_sub_dirs"],"SetSearchDirectories",{},2,0],[["n_directories","search_directories","search_sub_dirs"],"GetSearchDirectories",{},0,0],[["reference_sets"],"SetDefaultReferenceSets",{},1,0],[["n_reference_sets"],"GetDefaultReferenceSets",{R_:{reference_sets:""}},0,0],[["options_file"],"Save",{},1,0],[["options_file"],"Restore",{},1,0]],[]];
SPLM.LoadOptions = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.LoadOptions";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LoadOptions.LoadMethod = Object.freeze({
    "AsSaved" : "AsSaved", "FromDirectory" : "FromDirectory", "SearchDirectories" : "SearchDirectories"});

SPLM.LoadOptions.ManagedModeLoadMethod = Object.freeze({
    "ByRevisionRule" : "ByRevisionRule", "AsSaved" : "AsSaved"});

SPLM.LoadOptions.LoadComponents = Object.freeze({
    "All" : "All", "None" : "None", "LastSet" : "LastSet", "LastFilter" : "LastFilter", "SpecifyFilter" : "SpecifyFilter"});

SPLM.LoadOptions.Parent = Object.freeze({
    "Partial" : "Partial", "Immediate" : "Immediate", "All" : "All"});

SPLM.LoadOptions.BookmarkComponents = Object.freeze({
    "NoChange" : "NoChange", "LoadVisible" : "LoadVisible", "LoadLoaded" : "LoadLoaded", "LoadLoadedAndNonDisplayed" : "LoadLoadedAndNonDisplayed"});

SPLM.LoadOptions.BookmarkRefsets = Object.freeze({
    "ImportData" : "ImportData", "ImportAndOptimizeLoad" : "ImportAndOptimizeLoad", "DontImport" : "DontImport"});

SPLM.LoadOptions.UpdateSubsetOnLoad = Object.freeze({
    "None" : "None", "ReplayRecipe" : "ReplayRecipe"});

SPLM.LoadOptions.LoadOption = Object.freeze({
    "FullyLoad" : "FullyLoad", "PartiallyLoad" : "PartiallyLoad", "FullyLoadLightweightDisplay" : "FullyLoadLightweightDisplay", "PartiallyLoadLightweightDisplay" : "PartiallyLoadLightweightDisplay", "MinimallyLoadLightweightDisplay" : "MinimallyLoadLightweightDisplay"});

export default SPLM;